(() => {
	angular.module('main').factory('jobDataService', jobDataService);

	jobDataService.$inject = ['$http', '$q'];

	function jobDataService($http, $q) {
		return {
			addNewClient,
			editJob,
			getActiveJobs,
			getJobInfo,
			getJobTypes,
			getJobsOnPage,
			// getPrimaryClient,
			getWorkflowNames,
			fillClientSearchText,
			searchClient,
			updateClient
		};

		function getJobTypes() {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/job/types/all'
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function getWorkflowNames() {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/job/source'
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function getJobInfo(id, showNewTaskId = '') {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/jobs/view',
				params: {
					id,
					showNewTaskId
				}
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function editJob(job) {
			const deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/add_new_job/update',
				data: job
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function addNewClient(client) {
			const deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/clients/add',
				data: client
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function updateClient(client) {
			const deferred = $q.defer();

			$http({
				method: 'POST',
				url: '/protected/rest/clients/update',
				data: client
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function fillClientSearchText(client) {
			let { email, firstName, id, lastName = ' ' } = client;

			lastName = lastName === null ? ' ' : lastName;

			return {
				id,
				name: `${firstName} ${lastName} (${email})`
			};
		}

		function searchClient(searchClient) {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/job/client/search',
				params: {
					search: searchClient
				}
			})
				.then(
					response => {
						deferred.resolve(response);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function getActiveJobs() {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/protected/rest/jobs/active'
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function getJobsOnPage(pageRequest, active) {
			const {
				perPage,
				page,
				pageOrder: { predicate, reverse },
				search
			} = pageRequest;
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: '/api/user/jobs',
				params: {
					perPage,
					page,
					predicate,
					reverse,
					search,
					active
				}
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/dataServices/jobDataService.js